/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  FirstDerivative,
  FirstDerivativeInterface,
} from "../FirstDerivative";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "derivativePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getDepthOfDerivative",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getDerivative",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getUnderlying",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxDerivativeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mintDerivative",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "setDerivativePrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "depth",
        type: "uint256",
      },
    ],
    name: "setMaxDerivativeDepth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "royalty",
        type: "uint256",
      },
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class FirstDerivative__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    name: string,
    symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FirstDerivative> {
    return super.deploy(
      name,
      symbol,
      overrides || {}
    ) as Promise<FirstDerivative>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(name, symbol, overrides || {});
  }
  attach(address: string): FirstDerivative {
    return super.attach(address) as FirstDerivative;
  }
  connect(signer: Signer): FirstDerivative__factory {
    return super.connect(signer) as FirstDerivative__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FirstDerivativeInterface {
    return new utils.Interface(_abi) as FirstDerivativeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FirstDerivative {
    return new Contract(address, _abi, signerOrProvider) as FirstDerivative;
  }
}
